module.exports = __webpack_public_path__ + "static/finished-app-ca95b26aee27381714b3d645200494c5.jpg";